/**
 * Stage constructor
 * @constructor editor.actionbar.TopBar
 * @param {object} dom DOM
 */

fx.ns("desktop.common.actionbar", class TopBar extends fx.components.VBox {
    
	constructor(creation, options)
	{
		super(creation);
		
		this.creation = creation;
		this.options = Object.assign(this.defaults, options || {});

		this.listenUpdates(creation.elements, true);
	}

	get defaults()
	{
		return  { order : true, exit : true, edit : false};
	}

	onReady()
	{
		super.onReady();

		if (this.orderButton && this.orderBackground)
		{
			this.on("click", this.onOrder, this.orderButton);
			this.on("click", this.onOrder, this.orderBackground);
			this.on("mouseover", this.onOrderHover, this.orderBackground);
			this.on("mouseout", this.onOrderOut, this.orderBackground);
			this.on("mouseover", this.onOrderHover, this.orderButton);
			this.on("mouseout", this.onOrderOut, this.orderButton);
		}
		if (this.exitButton)
			this.on("click", this.onExit, this.exitButton);
	}

	create()
	{
		super.create();

		if (this.options.order)
		{
			this.orderButton = new fx.components.IconButton({className : "orderButton", icon:fx.assets.OrderIcon, label : fx.text("Commander"), filled : true});
            this.orderButton.attr("data-testid", "edition-order");
			this.orderBackground = new fx.components.Box("orderBackground");
			this.addChild(this.orderButton, {left:"center", height:85, width:85} );
			this.addChild(this.orderBackground, {top:0, right: 0, height:65, width: 65} );
			
			// order button text content
			this.priceText = new fx.components.VBox({className : "priceText" , left:0});
			this.orderText = new fx.components.HBox({className : "orderText" , left:0});
			this.orderText.addClass("fadeOutLeft");
			this.arrow = new fx.components.IconButton({className : "arrow", icon : fx.assets.OrderArrow});
			this.text1 = new fx.components.Text(fx.text("Prix") + " ");
			this.text1.addClass("infos");
			this.text2 = new fx.components.Text(this.creation.totalPrice);
			this.text2.addClass("price");
			this.priceText.addChild(this.text1, {width: "100%"});
			this.priceText.addChild(this.text2, {width: "100%"});
			this.orderText.addChild(this.priceText, {width: "74%", height: "30px", top : "12", left: 0});
			this.orderText.addChild(this.arrow, {width: "20%", height: "35px", top : "11", left: 0});
			this.orderBackground.addChild(this.orderText, {width:"115", left:10, top: "-2"});
		}

		if (this.options.exit)
		{
			this.exitButton = new fx.components.IconButton({icon:fx.assets.LeaveIcon, label : fx.text("Sauver & Quitter"), className : "exit"});
			this.exitButton.toolTip = fx.text("Sauver & Quitter");
			this.exitButton.toolTypeStyle = { position : "left", positionMargin : 20 };
			
			this.addChild(this.exitButton, {left:"center", height:70, width:70} );		
		}

		
	}

	onOrder()
    {
		this.trigger("order");
	}

	onExit()
	{
		this.trigger("exit");
	}

	onOrderHover(){
		this.orderBackground.width(180);
		this.orderText.removeClass("fadeOutLeft");
		this.orderText.addClass("fadeInLeft");
		this.arrow.removeClass("fadeOutLeft");
		this.arrow.addClass("fadeInLeft");
	}

	onOrderOut(){
		this.orderBackground.width(65);
		this.orderText.removeClass("fadeInLeft");
		this.orderText.addClass("fadeOutLeft");
		this.arrow.removeClass("fadeInLeft");
		this.arrow.addClass("fadeOutLeft");
	}


	onDataUpdated()
	{
		if (this.text2)
			this.text2.text = this.creation.totalPrice;
	}

	onChildUpdated(action)
	{
		if (action.impacts("quantity") && this.text2)
			this.text2.text = this.creation.totalPrice;
	}
	
});